module.exports = {
	"account.user.driving.licence.already.exist": "Já existe uma conta com o mesmo número de carta de condução.",
	"account.user.login.already.exist": "Este e-mail já está a ser utilizado por outra conta.",
	"account.user.suspended": "Incapaz de realizar esta ação porque o usuário está suspenso",
	"action.add.payment": "Adicionar método de pagamento",
	"action.complete.my.account": "Complete minha conta",
	"action.confirm.welcome.msg": "Vamos",
	"action.create.my.account": "Criar a minha conta",
	"action.search.update.bookings": "Verificar disponibilidades",
	"action.update.payment": "Atualizar método de pagamento",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Ao clicar em “Confirmar”, declara sob compromisso de honra que aceita os termos e condições de serviço e que é titular de uma carta de condução válida para utilizar o serviço de partilha de automóvel. Mais em {link}.",
	"booking.accept_usage_terms.title": "Termos de utilização",
	"booking.action.cancel.forbidden": "Já não pode cancelar a reserva",
	"booking.action.edit.forbidden": "Não pode mais editar uma reserva",
	"booking.add.calendar": "Adicionar ao calendário",
	"booking.confirm": "Confirmar reserva",
	"booking.confirm_and_pay": "Confirmar e pagar",
	"booking.deposit": "Caução",
	"booking.deposit.b": "Um depósito bancário de {damageSafetyDeposit} {currency} será cobrado quando você confirmar sua reserva.\n Este depósito pode ser usado para cobrir eventuais danos causados ao veículo durante a viagem. \n\n Se o veículo for devolvido sem nenhum dano ou horas extras, apenas o preço de {bookingPrice} {currency} será cobrado.",
	"booking.deposit.d": "Um depósito bancário no valor de {bufferPrice} {currency} será feito quando você confirmar sua reserva.\n Isso inclui o preço da sua reserva e uma taxa para cobrir quaisquer excedentes. \n\n Sem superação ou danos ao veículo, apenas {bookingPrice} {currency} será debitado de sua conta.",
	"booking.deposit.db": "Dois depósitos bancários serão cobrados quando você confirmar sua reserva:\n - O primeiro no valor de {bufferPrice} {currency} , incluindo o preço de sua reserva e uma cobrança para cobrir quaisquer excedentes.\n - O segundo no valor de {damageSafetyDeposit} {currency} para cobrir qualquer dano causado ao veículo durante sua reserva. \n\n Sem qualquer excesso ou danos ao veículo, apenas {bookingPrice} {currency} será cobrado.",
	"booking.deposit.info": "Será feito um depósito para a sua reserva",
	"booking.payment.prebilling.refused.error": "A transação foi recusada porque o débito no seu cartão de crédito falhou. Repita com outro cartão. Se o problema persistir, verifique com o seu banco.",
	"booking.payment.prebilling.technical.error": "Ocorreu um erro durante o pagamento. Tente novamente mais tarde.",
	"booking.success.sub.title": "Obrigado por utilizar o nosso serviço!",
	"booking.success.title": "Parabéns, a sua reserva foi criada com sucesso!",
	"booking.type.label": "Tipo de reserva",
	"booking.type.one_way": "Ida simples",
	"booking.type.return_trip": "Ida e volta",
	"booking.update.period.expired": "O período de atualização das datas de reserva expirou",
	"booking.usage.business": "Empresarial",
	"booking.usage.private": "Privado",
	"booking.view_payment_terms.title": "Termos de pagamento",
	"booking.voucher.different.code": "Não pode modificar o seu código promocional",
	"booking.voucher.placeholder": "Código promocional",
	"car.AUTOMATIC": "Automática",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Elétrico",
	"car.FOLDING_SEATS": "Assentos dobráveis",
	"car.GPS": "GPS",
	"car.HYBRID": "Híbrido",
	"car.LPG": "GPL",
	"car.MANUAL": "Manual",
	"car.PETROL": "Gasolina",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Detalhes da reserva",
	"car.color": "Cor",
	"car.compact_cars": "Compactar",
	"car.description": "Description",
	"car.details": "Detalhes do veículo",
	"car.doors": "Portas",
	"car.filter.COMMERCIAL": "Comercial",
	"car.filter.PASSENGER": "Turismo",
	"car.filter.accessories.air_conditioning": "Ar condicionado",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Camião grande",
	"car.filter.accessories.radio_cd": "Rádio",
	"car.filter.label_nb_persons": "Número de pessoas",
	"car.filter.other": "Outros",
	"car.filter.other-nb": "Outros - {nb}",
	"car.filter.vehicle_type": "Tipo de veículo",
	"car.filter_energy": "Energia",
	"car.filter_gearbox_type": "Tipo de caixa de velocidades",
	"car.filter_persons": "pessoas",
	"car.for_every_additional_km": "Por quilómetro adicional",
	"car.km_included": "Km incluídos",
	"car.motorization": "Motor",
	"car.options": "Opções",
	"car.parking_additional_info": "Detalhes específicos do estacionamento",
	"car.places": "Lugares",
	"car.pricing": "Preços",
	"car.pricing.estimate": "Estimativa do preço",
	"car.pricing.extra_km_cost_per_day": "Preço de km extra",
	"car.pricing.free_km_per_day": "Km inclui / 24 h",
	"car.specifications": "Especificações",
	"car.transmission": "Transmissão",
	"car.utility_cars": "Serviço",
	"car.version": "Versão",
	"company.id.missing.booking.search": "O id da empresa é obrigatório para a pesquisa de reserva anônima",
	"contact_page.phone_call_price": "(CHAMADA GRATUITA A PARTIR DE UMA LINHA FIXA)",
	"contact_page.title_1": "Para qualquer questão relacionada com o seu aluguer de viaturas,",
	"contact_page.title_2": "não hesite em contactar-nos por e-mail.",
	"creditcard.data.insufficient.3ds": "Devido aos novos requisitos do 3DS2, pedimos que você atualize suas informações de pagamento.",
	"custom.field.type.boolean": "Sim/Não",
	"data.with.colon": "{data}:",
	"document.issue.date": "Data de emissão",
	"dropzone.inner.info": "Ficheiros permitidos: JPEG, PNG, PDF",
	"dropzone.inner.title": "Carregue o seu documento",
	"error.booking.member_invalid": "O seu perfil ainda não foi validado.",
	"error.booking.no.usage": "Sem uso para essas datas de reserva",
	"error.booking.no_credit_card": "Adicione primeiro as informações do seu cartão de crédito.",
	"error.booking.same_period": "Já tem uma reserva planeada para este período.",
	"error.change_password.400.bad_request": "A palavra-passe está errada",
	"error.contract.inactive": "O serviço não está ativo para a sua empresa, contacte o seu gestor de serviços.",
	"error.contract.not-found": "O serviço foi suspenso pela sua empresa, contacte o seu gestor de serviços.",
	"error.credit.card.refused": "Cartão de crédito recusado",
	"error.forgot_password.404": "Verifique o seu e-mail, sem contas correspondentes",
	"error.form.email.already_exists": "Introduza outro endereço de e-mail",
	"error.form.email_invalid": "Introduza um endereço de e-mail válido",
	"error.form.inviteCode.notEmpty": "Introduza um código de convite",
	"error.form.password.at_least": "A sua palavra-passe tem de conter, pelo menos, 8 carateres",
	"error.form.password.at_most": "A sua palavra-passe tem de conter um máximo de 25 carateres",
	"error.form.password.cannot_reset_same": "A nova palavra-passe tem de ser diferente da atual",
	"error.form.password.digit": "A sua palavra-passe tem de conter 1 número",
	"error.form.password.lower_letter": "A sua palavra-passe tem de conter 1 letra minúscula",
	"error.form.password.upper_letter": "A sua palavra-passe tem de conter 1 letra maiúscula",
	"error.form.password_confirmation.the_same": "Introduza duas vezes a mesma palavra-passe",
	"error.form.password_old.the_same": "A nova palavra-passe tem de ser diferente da antiga",
	"error.form.required": "Preencha todos os campos obrigatórios",
	"error.form.suggestion.address.required": "Selecione um endereço a partir da lista de sugestões",
	"error.form.technical": "Erro técnico",
	"error.get.site.config": "Falha ao carregar a configuração do site",
	"error.invite.code.invalid": "A comunidade da qual você deseja participar não existe",
	"error.login.401.unauthorized": "O seu e-mail ou palavra-passe estão incorretos.",
	"error.login.403.user.anonymized": "A sua conta é anónima, não pode continuar a utilizá-la",
	"error.login.422.user.not.enabled": "A sua conta não está ativada, verifique os seus e-mails e siga as instruções para ativar a sua conta.",
	"error.number.above.max": "O valor não pode ser superior a {value}",
	"error.number.below.min": "O valor não pode ser inferior a {value}",
	"error.phone.format.invalid": "O formato do número de telefone introduzido está incorreto",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Erro do pedido",
	"error.reset_password.401": "O link fornecido já não é válido, solicite outra palavra-passe no site",
	"error.search.vehicles.403": "Você não pode acessar o site selecionado com o perfil ativo atual",
	"error.session.expired": "Sessão expirada",
	"error.text.length.long": "Este campo está limitado a {count} carateres",
	"error.text.length.short": "O campo requer um mínimo de {count} carateres",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "O nome e a data de nascimento não podem ser alterados após a validação do seu perfil",
	"faq.contactEmailFallback": "o nosso e-mail de contacto",
	"faq.contactPhoneFallback": "na parte superior da página",
	"faq.other_question": "Não consegue encontrar respostas para as suas perguntas?",
	"file_upload_size_exceeded": "O ficheiro é demasiado grande. Tamanho máximo: 5 MB",
	"footer.label.legal.information": "Informação legal",
	"footer.label.personal.data": "Dados pessoais",
	"footer_callUs": "Ligue-nos",
	"footer_other": "Outros",
	"footer_share": "Siga-nos",
	"footer_society_about": "Sobre nós",
	"footer_society_policy_privacy": "Política de privacidade",
	"footer_society_term": "Termos de utilização",
	"footer_writeUs": "Escreva-nos um e-mail",
	"forgot_password.confirmation": "Foi enviado para o seu endereço de e-mail um link para reposição da sua palavra-passe.",
	"forgot_password.description_line1": "Introduza o endereço de e-mail associado à sua conta.",
	"forgot_password.description_line2": "Vamos enviar-lhe um link para repor a sua palavra-passe.",
	"forgot_password.submit": "Envie-me o link de redefinição",
	"generic.address": "Endereço",
	"generic.at": "para",
	"generic.book": "Reservar",
	"generic.cancel": "Cancelar",
	"generic.canceled": "Cancelada",
	"generic.city": "Cidade",
	"generic.clear": "Limpar",
	"generic.company": "Empresa",
	"generic.completed": "Concluída",
	"generic.country": "País",
	"generic.email": "E-mail",
	"generic.end": "Fim",
	"generic.expires.at": "Validade",
	"generic.extend": "Prolongar",
	"generic.file": "Ficheiro",
	"generic.first.name": "Primeiro nome",
	"generic.last.name": "Último nome",
	"generic.location.fixture.label": "Locais",
	"generic.location.history.label": "História",
	"generic.location.search.placeholder": "Pesquise um endereço, uma cidade, etc.",
	"generic.mobile.phone": "Telemóvel",
	"generic.modify": "Modificar",
	"generic.mr": "Sr.",
	"generic.mrs": "Sr.ª",
	"generic.next": "Seguinte",
	"generic.number": "Número",
	"generic.passport": "Passaporte",
	"generic.past.placeholder": "Encontre aqui as suas reservas anteriores",
	"generic.phone.number": "Número de telefone",
	"generic.postal.code": "Código postal",
	"generic.retry": "Tentar novamente",
	"generic.save": "Guardar",
	"generic.send": "Enviar",
	"generic.start": "Começar",
	"generic.text": "Texto",
	"generic.today": "Hoje",
	"generic.upcoming": "Próximas",
	"generic.updated": "Atualizada",
	"generic.user": "Utilizador",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Para registar, basta aceder ao site de intranet da sua empresa e encontrar a ligação para a interface de registo. (Ou enviar um pedido para ser incluído em {contactEmail}). Receberá uma ligação por e-mail.",
	"helpPage_carSharing_issue1_title": "Como posso registar-me?",
	"helpPage_carSharing_issue2_answer": "Pode repor a sua palavra-passe no website ou aplicação móvel: neste caso, receberá no seu endereço de e-mail registado uma ligação para definir a sua palavra-passe.",
	"helpPage_carSharing_issue2_title": "E se perder a minha palavra-passe?",
	"helpPage_carSharing_issue3_answer": "Caso perca o seu identificador ou tiver um novo, contacte o Centro de Atendimento através do número {contactPhone} para repor o seu identificador. O novo identificador não funciona até que o reponha.",
	"helpPage_carSharing_issue3_title": "E se perder o meu identificador ou tiver um novo?",
	"helpPage_carSharing_issue4_answer": "A matrícula do veículo está indicada no e-mail de confirmação e no SMS de confirmação. Caso contrário, pode encontrar o veículo no website de reserva My Bookings (As minhas reservas).",
	"helpPage_carSharing_issue4_title": "Que veículo reservei?",
	"helpPage_carSharing_issue5_answer": "Certifique-se de que a data e hora estão corretas, o botão de início apenas está disponível no momento da reserva. Caso contrário, pode passar o seu identificador no leitor de cartões para abrir as portas do veículo.",
	"helpPage_carSharing_issue5_title": "Porque não existe um botão para iniciar?",
	"helpPage_carSharing_issue6_answer": "Se efetuou uma reserva e a luz está verde, mas as portas não abrem, prima o botão no manípulo da porta.",
	"helpPage_carSharing_issue6_title": "Porque existe uma luz verde, mas as portas continuam fechadas?",
	"helpPage_carSharing_issue7_answer": "Após reservar o seu veículo, também pode editar ou cancelar a sua reserva no website ou na aplicação móvel. Se necessitar de assistência, contacte o Centro de Atendimento através do número {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Editar/Cancelamento",
	"helpPage_carSharing_issue8_answer": "Não, apenas pode abrir o veículo a partir da hora da reserva.",
	"helpPage_carSharing_issue8_title": "Posso passar o meu identificador antes da hora da reserva?",
	"helpPage_damages_issue1_answer": "Antes de iniciar a sua reserva, notifique os possíveis danos através da sua aplicação móvel ou contacte o Centro de Atendimento através do número {contactPhone}.",
	"helpPage_damages_issue1_title": "O que devo fazer em caso de existirem danos no veículo reservado?",
	"helpPage_damages_issue2_answer": "Mantenha-se calmo e certifique-se de que não existem feridos. Está coberto pelo seguro. Contacte o Centro de Atendimento imediatamente através do número {contactPhone} para obter instruções.",
	"helpPage_damages_issue2_title": "O que devo fazer em caso de acidente durante a minha reserva?",
	"helpPage_subtitle": "Nesta secção encontra as respostas para as perguntas mais frequentes.",
	"helpPage_tab_carSharing": "Serviço",
	"helpPage_tab_damages": "Danos",
	"helpPage_tab_vehicles": "Veículo",
	"helpPage_title": "Perguntas mais frequentes (FAQ)",
	"helpPage_vehicles_issue1_answer": "Verifique a data e hora da sua reserva, comprove se a matrícula corresponde à sua reserva. Em seguida, passe novamente apresentando APENAS o identificador ao leitor. Certifique-se de que utiliza o identificador pertence à pessoa que efetuou a reserva e que não foi alterado entre a última reserva e esta. Em caso de uma alteração recente do identificador, agradecemos que contacte o atendimento ao cliente para efetuar a alteração imediatamente.",
	"helpPage_vehicles_issue1_title": "Porque o veículo não responde?",
	"helpPage_vehicles_issue2_answer": "Verifique a data e hora da sua reserva, comprove se a matrícula corresponde à sua reserva. Certifique-se de que possui o identificador correto (o identificador da pessoa que efetuou a reserva).",
	"helpPage_vehicles_issue2_title": "Porque o leitor de cartões apresenta apenas a luz vermelha?",
	"helpPage_vehicles_issue3_answer": "Se tem uma reserva e a luz está verde, mas as portas não abrem, prima o botão na porta do condutor para desbloquear as portas.",
	"helpPage_vehicles_issue3_title": "Porque as portas continuam fechadas?",
	"helpPage_vehicles_issue4_answer": "Certifique-se de que a matrícula e a data e hora estão corretos e de que possui uma ligação à Internet.",
	"helpPage_vehicles_issue4_title": "Porque não posso abrir as portas?",
	"helpPage_vehicles_issue5_answer": "Certifique-se de que o motor está desligado, as portas e o porta-bagagens estão devidamente fechados, e colocou as chaves com o chip na caixa no porta-luvas.",
	"helpPage_vehicles_issue5_title": "Porque não posso trancar o veículo?",
	"home.header_banner": "Em outubro, a <strong> Mobilidade Renault </strong> se tornará a <strong> participação do Mobilize </strong>",
	"home.welcome": "Damos-lhe as boas-vindas ao {productName}",
	"home.welcome_solo": "Damos-lhe as boas-vindas",
	"how_it_works.step_1": "<span class='bold'>Transfira a aplicação</span> a partir da App Store ou Google Play.",
	"how_it_works.step_2": "Abra a aplicação e <span class='bold'>registe-se</span> ao preencher o formulário.",
	"how_it_works.step_3": "Tire uma fotografia da sua <span class='bold'>carta de condução</span>, do seu <span class='bold'>cartão de identificação</span> e <span class='bold'>uma selfie</span> com o seu cartão de identificação ao lado do seu rosto, e guarde tudo na aplicação!",
	"how_it_works.step_4": "<span class='bold'>Registe o seu cartão bancário</span> para gerir o pagamento dos seus alugueres.",
	"how_it_works.step_5": "<span class='bold'>Valide o seu endereço de e-mail</span> ao clicar no link que lhe enviámos. <span class='bold'>Verifique a sua pasta de SPAM</span>.",
	"how_it_works.step_6": "Depois de o seu registo ter sido validado, <span class='bold'>reserve o seu veículo</span> na nossa aplicação ou no nosso site. No dia da sua reserva, <span class='bold'>o seu telemóvel é a sua chave!</span>",
	"info.account.company.already.linked": "Esta empresa já está vinculada à sua conta",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Mudando de perfil",
	"info.worldpay.return.success": "Informação de pagamento anexada",
	"iso__BE": "Bélgica",
	"iso__CS": "República Checa",
	"iso__DA": "Dinamarca",
	"iso__DE": "Alemanha",
	"iso__ES": "Espanha",
	"iso__FR": "França",
	"iso__IT": "Itália",
	"iso__NL": "Países Baixos",
	"iso__PL": "Polónia",
	"iso__PT": "Portugal",
	"iso__SL": "Eslovénia",
	"iso__SV": "Suécia",
	"iso__pt_BR": "Brasil",
	"label.accept_terms_and_conditions": "Aceito ser contactado subsequentemente pela Renault e pela sua rede por e-mail para as finalidades de investigar ou informar sobre novos produtos, bem como ofertas atuais. No momento de cada envio, terei a possibilidade de terminar todas as comunicações.",
	"label.account.already.active": "A sua conta já está ativada",
	"label.account_activation_description": "Irá receber uma confirmação por e-mail quando a conta tiver sido validada, e poderá, então, aproveitar todas as vantagens do serviço.",
	"label.account_activation_title": "A sua conta será validada, no máximo, nos próximos 15 minutos.",
	"label.activation.link.expired": "O link de ativação expirou",
	"label.activation.link.send": "Reenviar",
	"label.activation.link.sent.success": "O e-mail de ativação será enviado se o utilizador existir e a conta não estiver ativada",
	"label.active.profile": "Perfil ativo",
	"label.actual.payment.method": "O seu método de pagamento atual",
	"label.add.new.profile": "Adicionar novo perfil",
	"label.apply": "Aplicar",
	"label.are_you_sure_you_want_to_cancel": "Pretende confirmar o seu cancelamento?",
	"label.birth.day": "Data de nascimento",
	"label.booking": "Reserva",
	"label.booking.past": "Anteriores",
	"label.booking.past.placeholder": "Encontre aqui o seu histórico de reservas.",
	"label.booking.today.part": "hoje às",
	"label.booking.upcoming.placeholder": "Encontre aqui suas reservas programadas e em progresso",
	"label.cancel_my_booking": "Cancelar a minha reserva",
	"label.car": "veículo",
	"label.carSharing": "Compartilhamento de carro",
	"label.cars": "veículos",
	"label.civility": "Estado civil",
	"label.click_here": "Clique aqui",
	"label.close": "Fechar",
	"label.confirm_new_password": "Confirmar palavra-passe",
	"label.congratulations": "Parabéns!",
	"label.continue": "Continuar",
	"label.creditCard_message": "Para validar o seu cartão, efetuaremos um débito temporário. Poderá ser mostrado temporariamente um débito no pequeno valor de {amountToTake} € na conta associada ao seu cartão. Se o débito persistir durante mais de cinco dias úteis, contacte o seu banco.",
	"label.date": "Data",
	"label.delivery_place": "Cidade de emissão",
	"label.driving_licence": "Carta de condução",
	"label.driving_licence_back": "Carta de condução (verso)",
	"label.driving_licence_front": "Carta de condução (frente)",
	"label.edit.invite.code": "Editar código de convite",
	"label.expiration_date": "Data de validade",
	"label.file.upload.only.mobile": "Para editar documentos, utilize a aplicação móvel.",
	"label.filter_by": "Filtrar por",
	"label.filters": "Filtros",
	"label.generic.error": "Ocorreu um erro. Tente novamente mais tarde.",
	"label.hours": "horas",
	"label.how_it_works": "Como funciona?",
	"label.identity.card": "Cartão de identificação",
	"label.identity.document.number": "Número do documento de identificação",
	"label.identity.document.type": "Tipo de documento de identificação",
	"label.identity_card": "Documento de identificação",
	"label.identity_card_back": "Documento de identificação (verso)",
	"label.identity_card_front": "Documento de identificação (frente)",
	"label.identity_card_selfie": "Fotografia com o seu documento de identificação",
	"label.invite_code_placeholder": "Introduza o código de convite",
	"label.italy.fiscal.code": "Insira o número fiscal",
	"label.italy.resident": "Você é italiano?",
	"label.licence_number": "Número da carta de condução",
	"label.load_more": "Mais resultados",
	"label.login": "Iniciar sessão",
	"label.logout": "Terminar sessão",
	"label.manager.email": "Email do seu gerente",
	"label.mandatory_fields": "* Campos obrigatórios",
	"label.member_already": "Já é membro?",
	"label.my_account": "A minha conta",
	"label.my_reservations": "As minhas reservas",
	"label.new.password": "Nova palavra-passe",
	"label.no_account": "Novo membro?",
	"label.or_by_phone": "Ou por telefone",
	"label.password": "Palavra-passe",
	"label.password_forgot": "Palavra-passe esquecida",
	"label.phone": "Telefone",
	"label.phone.suffix": "Indicativo do telefone",
	"label.plateNumber": "Número da placa",
	"label.price": "preço",
	"label.redirectMobileApp": "Para iniciar a sua reserva, transfira a nossa aplicação móvel!",
	"label.remember_me": "Manter a sessão iniciada",
	"label.reset_password_done": "A sua palavra-passe foi atualizada",
	"label.return": "Voltar",
	"label.schedule": "Horas",
	"label.search": "Pesquisar",
	"label.selected.language": "Idioma selecionado",
	"label.subject": "Assunto",
	"label.switch.profile": "Mudar de perfil",
	"label.the": "para",
	"label.validate": "Validar",
	"label.vehicles_found": "{count} resultados encontrados",
	"label.warning": "Aviso",
	"label.welcome.finish.registration": "Para confirmar sua consulta, finalize seu cadastro.",
	"label.you_are_trying_to_cancel_your_booking": "Está prestes a cancelar a sua reserva!",
	"label.your.active.profile": "Seu perfil ativo",
	"label.your.other.profiles": "Seus outros perfis",
	"label.your_message": "A sua mensagem",
	"language.header": "Selecione o seu idioma",
	"login.forgot_password": "Esqueceu-se da palavra-passe?",
	"login.register": "Registo",
	"menu.faq": "Informação",
	"mobile_banner.text": "Faça download do aplicativo {productName}",
	"page.password.update.sub.title": "Por motivos de segurança, pedimos que você atualize sua senha",
	"page.password.update.title": "Atualização de senha",
	"parking.special_opening_legend": "Horas especiais de abertura",
	"part.company.fill.extra.info": "pede-lhe para preencher algumas informações adicionais.",
	"part.complete.register.for": "Finalize o seu registo para",
	"part.create.account.for": "Criar uma conta para",
	"part.link.account.to": "Vincule sua conta a",
	"part.your.email": "seu email",
	"placeholder.enter.number": "Insira um número ...",
	"placeholder.enter.text": "Digite aqui ...",
	"placeholder.search": "Pesquisar ...",
	"profile.422.error.info": "Parece que algumas informações estão faltando em seu perfil.\n Vamos verificar juntos o seu perfil para ter certeza de que está tudo bem.",
	"profile.info.new.email": "Se atualizar o seu endereço de e-mail, irá receber um e-mail para verificar o seu endereço de e-mail. Se não o verificar, deixará de poder criar uma reserva.",
	"profile.label.before.arrival": "Antes da chegada",
	"profile.label.before.departure": "Antes da partida",
	"profile.label.charges.call.center": "Para alterações feitas pelo call center",
	"profile.label.charges.my": "Forem efetuadas alterações por mim",
	"profile.label.current.password": "Palavra-passe atual",
	"profile.label.expiration.date.status": "Minha carteira de habilitação não tem data de validade",
	"profile.label.min.15": "15 minutos",
	"profile.label.min.30": "30 minutos",
	"profile.label.min.45": "45 minutos",
	"profile.label.new.email": "Novo endereço de e-mail",
	"profile.label.street.field": "Endereço (número + nome da rua)",
	"profile.label.validated.email": "O seu endereço de e-mail validado",
	"profile.section.additional.info": "Informações adicionais",
	"profile.section.credentials": "Credenciais",
	"profile.section.language": "Linguagem do perfil",
	"profile.section.notifications": "Notificações e alertas",
	"profile.section.payment.info": "Informações de pagamento",
	"profile.section.personal.info": "Informações pessoais",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Acesso técnico",
	"profile.select.menu.item": "Selecione um item do menu à esquerda",
	"profile.selfie.section.info": "Tire uma selfie onde mostra o seu cartão de identificação ao lado do seu rosto.",
	"profile.suspended": "Seu perfil está suspenso",
	"profile.title.email.notifications": "Notificações por e-mail",
	"profile.title.language.select": "Idioma usado para notificações e e-mails",
	"profile.title.sms.notifications": "Notificações por SMS",
	"profile.title.update.email": "Atualizar o seu endereço de e-mail",
	"profile.title.update.password": "Atualizar a sua palavra-passe",
	"profile_error_driver_license_invalid": "A carta de condução não é válida",
	"register.field.info.password": "Tem de conter, pelo menos, 1 número, 1 letra maiúscula, 1 letra minúscula e entre 8 e 25 carateres",
	"register.info.payment.saved": "O método de pagamento foi guardado.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Foi enviado um link de ativação para {email}. Verifique os seus e-mails e a sua pasta de spam e, depois, siga as instruções para ativar a sua conta antes da ligação expirar.",
	"register.terms.ads": "Autorizo o processamento dos meus dados para fins de marketing (tanto com métodos automatizados como tradicionais) em relação a produtos e / ou serviços de mobilidade.",
	"register.terms.prefix.accept": "Aceito os",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "política de privacidade",
	"register.terms.root.tos": "termos de subscrição",
	"register.terms.root.tou": "termos de utilização",
	"register.terms.suffix.ads": "utilizar os meus detalhes para finalidades comerciais",
	"register.terms.suffix.of": "de",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Parabéns {firstName}, a sua conta foi criada",
	"register.title.account.linked": "Parabéns {firstName}, novo perfil foi vinculado à sua conta",
	"register.title.account.updated": "Parabéns, {firstName}, a sua conta foi atualizada",
	"reset_password.title": "Reposição da palavra-passe",
	"search.filter_alphabetically": "Alfabeticamente",
	"search.filter_by": "Ordenar por",
	"search.filter_by_price": "Por preço",
	"search.result.empty": "Sem resultados",
	"service.corporate.intro": "Pretende aderir a uma comunidade? Introduza o seu código de convite.",
	"service.intro_label": "Que serviço da {productName} pretende subscrever?",
	"service.private.intro": "Pretende reservar um veículo da rede {productName}?",
	"service.private.renaultfr": "Para subscrever o serviço {productName}, transfira a aplicação a partir da sua loja de aplicações móveis.",
	"service.private.select_country": "Selecione um pais",
	"service.usage.corporate": "Partilha de carros empresarial",
	"service.usage.private": "Aluguer de viaturas 24/7",
	"service.usage.vr": "Veículo de substituição",
	"service.vr.intro": "Obrigado pelo seu interesse no nosso serviço!\n\nPara se tornar membro, contacte o seu revendedor para obter um link de registo.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Digite seu endereço de e-mail de trabalho",
	"sso.login.title": "Conecte-se com SSO",
	"status.APPROVED": "Perfil validado",
	"status.NOT_APPROVED": "Seu perfil foi rejeitado. Por favor, atualize seu perfil.",
	"status.TO_COMPLETE": "Incompleto",
	"status.TO_REVIEW": "Seu perfil está com validação pendente",
	"tagline": "Self-service 24/7 para aluguer de viaturas",
	"title.add.payment.later": "Você pode adicionar mais tarde.",
	"title.add.payment.method": "Adicione um método de pagamento.",
	"title.bookings.welcome.tutorial": "Encontre aqui a sua reserva, já está agendada",
	"title.modify.booking": "Modificar a minha reserva",
	"title.password.change.success": "A sua nova palavra-passe foi guardada",
	"title.update.booking": "Atualizar reserva",
	"title.welcome.to.brand": "Olá {firstName}, bem-vindo(a) ao {brandName}.",
	"title.welcome.to.program": "Olá {firstName}, bem-vindo ao programa {brandName} {program}.",
	"vehicle.incorrect.usage": "O veículo não está disponível para esse tipo de uso",
	"week.day.friday": "Sexta-feira",
	"week.day.monday": "Segunda-feira",
	"week.day.saturday": "Sábado",
	"week.day.sunday": "Domingo",
	"week.day.thursday": "Quinta-feira",
	"week.day.tuesday": "Terça-feira",
	"week.day.wednesday": "Quarta-feira"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/pt.json
 ** module id = 427
 ** module chunks = 0
 **/